import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {ID} from '~/lib/model';
import {fetchPayments} from '~/modules/Payments/api';
import {IPayment} from '~/modules/Payments/models/Payment';

export const PAYMENTS_QUERY_KEY = (sellerId?: ID) => ['payments', {sellerId: sellerId ?? null}] as const;

export const usePaymentsQuery = (sellerId?: ID): UseQueryResult<IPayment[]> =>
    useQuery<IPayment[]>({
        queryKey: PAYMENTS_QUERY_KEY(sellerId),
        queryFn: () => fetchPayments(sellerId ?? null),
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });
